import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss']
})
export class CardComponent extends BaseViewComponent{
    @Input() isLoading: boolean = false;
    @Input() qaTag: string = "";
    @Input() disablePadding: boolean = false;

    @ViewChild('card', {static: true}) card!: ElementRef;
}
